import React, { useContext, createContext, useEffect, useState } from "react";

export const initialPersistentState = {
  token: "",
  sessionData: null,
  users: {},
  EventFaq: [],
  EventTicketConfig: [],
  EventSchedule: [],
  EventVenue: [],
  Event: [],
  EventList: {},
  Coupon: {},
  WizardKey: 0,
  AddEventType: "",
  FullScreenLoader: false,
  FilledSteps: [0],
  IsGetByIdEvent: false,
  CheckOutData: {},
  EventId: 0,
  EventString: 0,
  customerInfo: {},
  couponInfo: {},
  paymentTypeId: 1002,
  paymentType: {},
  IsStripeSuccess: false,
  AddEvent: {},
  ResetAmount: false,
  isInViewport: false,
  toggleState: false,
  showSkeleton: false,
};

const initialContext = [{ ...initialPersistentState }, () => {}];

export const persistentContext = createContext(initialContext);

export const usePersistentState = () => useContext(persistentContext);

export function ProvideGlobalState({ children }: any) {
  const persistentState = useProvideAppState();
  return (
    <persistentContext.Provider value={persistentState}>
      {children}
    </persistentContext.Provider>
  );
}

export const useProvideAppState = () => {
  const [localAppState, setLocalAppState] = useState(initialPersistentState);
  const [state, dispatch] = React.useReducer(
    (oldState: any, newValue: any) => ({ ...oldState, ...newValue }),
    localAppState
  );

  useEffect(() => {
    setLocalAppState(state);
  }, [setLocalAppState, state]);

  return [state, dispatch];
};
